// ----------------------------------------------------------------------

export const email = [
  'lexodusk@gmail.com',
];
